import React from 'react';

export const EmptyDMIcon: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='136'
    height='137'
    fill='none'
    viewBox='0 0 136 137'
  >
    <path
      fill='var(--stroke)'
      fillRule='evenodd'
      d='M119.012 16.488c-1.235-1.235-3.109-1.87-4.995-1.243h-.002L13.053 47.779l-.034.017c-.668.334-1.292.974-1.747 1.732-.458.762-.772 1.691-.772 2.64 0 .948.314 1.877.772 2.64.455.758 1.08 1.398 1.747 1.732l.011.006 45.813 20.112 20.098 45.781c.673 1.979 2.648 2.562 4.392 2.562 1.886 0 3.767-1.249 4.4-3.146l.001-.004 32.511-100.896c.337-.702.314-1.528.084-2.294a5.288 5.288 0 00-1.317-2.172zm-57.394 50.66l-33.5-14.356 70.769-23.054-36.663 36.663a9.688 9.688 0 00-.333.343 1.533 1.533 0 00-.273.405zm7.343 6.826l36.794-36.793-23.048 70.216-14.403-33.074c.1-.07.175-.147.233-.204l.01-.01c.134-.135.147-.135.206-.135h.208z'
      clipRule='evenodd'
    ></path>
  </svg>
);
